<template>
  <div>
    <Progress progress="34"></Progress>
    <div class="person-header">
      <div class="header-title">
        {{ $t("personalInformation.contact_info") }}
      </div>
      <div class="ipt-box isdisable">
        <div class="ipt-main">
          <div class="val-box">
            <span class="label">{{$t("personalInformation.phone_field.label")}}</span>
            <span class="phone">+{{ personForm.zone_code }} {{ personForm.user_phone }}</span>
          </div>
        </div>
      </div>

      <div class="ipt-box" :class="{'focus':inputFocusId == 1,error: errorStatus && !personForm.email}">
        <div class="ipt-main email">
          <div class="val-box">
            <span class="label" v-if="personForm.email">{{ $t('personalInformation.email_field.label') }}</span>
            <van-field
              class="val"
              v-model="personForm.email"
              :placeholder="$t('personalInformation.email_field.label')"
              @input="handEmailSuffix"
              @blur="handError(personForm.email)"
              @focus="inputFocus(1)"
            ></van-field>
            <van-overlay :show="emailSuffixShow" class="overlay-top" :style="{ top: topDistance + 'px', width: dialogWidth + 'px' }"
                         :lock-scroll="false"  @click="emailSuffixShow = false"
            >
              <div class="symbolList-box">
                <div v-for="item in emailSuffixList" :key="item" @click="handSuffixClick(item)" class="cell-box">
                  {{ item }}
                </div>
              </div>
            </van-overlay>
          </div>
        </div>
        <p class="error" v-if="!personForm.email && errorStatus">{{ $t('personalInformation.error_tip.lang') }}</p>
      </div>
      <div class="email-tip">
        {{ $t("personalInformation.email_field.tip") }}
      </div>

      <div class="header-title1">
        {{ $t("personalInformation.education_module_title") }}
      </div>
      <div class="ipt-box isdisable1">
        <div class="ipt-main" @click="educationalPicker = true">
          <div class="val-box" :class="{'zIndex':emailSuffixShow}">
            <span class="label" :class="{ placeholder: !personForm.education }"
            >{{ $t("personalInformation.education_field.label") }}</span
            >
            <span class="val" v-if="personForm.education">{{ getSelectText(2,1) }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
      </div>

      <van-popup v-model="educationalPicker" position="bottom" class="picker-ui">
        <van-picker
          :columns="getInitList(2)"
          show-toolbar
          @cancel="educationalPicker = false"
          :default-index="getSelectText(2,2)"
          @confirm="onEducationalConfirm"
        />
      </van-popup>
      <div class="ipt-box">
        <div class="ipt-main" @click="careerPicker = true">
          <div class="val-box" :class="{'zIndex':emailSuffixShow}">
            <span class="label" :class="{ placeholder: !personForm.job_type }"
            >{{ $t('personalInformation.error_tip.lang14') }}</span
            >
            <span class="val" v-if="personForm.job_type">{{ getSelectText(1,1) }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
      </div>
      <van-popup v-model="careerPicker" position="bottom" class="picker-ui">
        <van-picker
          :columns="getInitList(1)"
          show-toolbar
          @cancel="careerPicker = false"
          :default-index="getSelectText(1,2)"
          @confirm="onCareerConfirm"
        />
      </van-popup>
      <div v-if="personForm.job_type == 1 || personForm.job_type == 2" class="other-box">
        <div class="ipt-box" :class="{'focus':inputFocusId == 2,error: errorStatus && !personForm.company}">
          <div class="ipt-main">
            <div class="val-box" :class="{'zIndex':emailSuffixShow}">
              <span class="label" v-if="personForm.company || inputFocusId == 2">{{ $t('personalInformation.error_tip.lang1') }}</span>
              <van-field
                class="val"
                v-model="personForm.company"
                :placeholder="inputFocusId == 2 ? '' : $t('personalInformation.error_tip.lang1')"
                @blur="handError(personForm.company)"
                @focus="inputFocus(2)"
              ></van-field>
            </div>
          </div>
          <p class="error" v-if="!personForm.company && errorStatus">{{ $t('personalInformation.error_tip.lang1') }}</p>
        </div>

        <div class="ipt-box" :class="{'focus':inputFocusId == 4,error: errorStatus && !personForm.vocation}">
          <div class="ipt-main">
            <div class="val-box" :class="{'zIndex':emailSuffixShow}">
              <span class="label" v-if="personForm.vocation || inputFocusId == 4">{{ $t('personalInformation.error_tip.lang5') }}</span>
              <van-field
                class="val"
                v-model="personForm.vocation"
                :placeholder="inputFocusId == 4 ? '' : $t('personalInformation.error_tip.lang5')"
                @blur="handError(personForm.vocation)"
                @focus="inputFocus(4)"
              ></van-field>
            </div>
          </div>
          <p class="error" v-if="!personForm.vocation && errorStatus">{{ $t('personalInformation.error_tip.lang6') }}</p>
        </div>

        <div class="ipt-box">
          <div class="ipt-main" @click="careerAttributesPicker = true">
            <div class="val-box" :class="{'zIndex':emailSuffixShow}">
            <span class="label" :class="{ placeholder: !personForm.vocation_attribute }"
            >{{ $t('personalInformation.error_tip.lang3') }}</span
            >
              <span class="val" v-if="personForm.vocation_attribute">{{ getSelectText(4,1) }}</span>
            </div>
            <span class="icon-arrow"></span>
          </div>
        </div>
        <van-popup v-model="careerAttributesPicker" position="bottom" class="picker-ui">
          <van-picker
            :columns="getInitList(4)"
            show-toolbar
            @cancel="careerAttributesPicker = false"
            :default-index="getSelectText(4,2)"
            @confirm="careerAttributesConfirm"
          />
        </van-popup>

<!--        <div class="ipt-box" :class="{error: !personForm.job_age && errorStatus}">-->
<!--          <div class="ipt-main" @click="jobAgePicker = true">-->
<!--            <div class="val-box" :class="{'zIndex':emailSuffixShow}">-->
<!--            <span class="label" :class="{ placeholder: !personForm.job_age }"-->
<!--            >{{ $t('personalInformation.error_tip.lang7') }}</span-->
<!--            >-->
<!--              <span class="val" v-if="personForm.job_age">{{ getSelectText(3,1) }}</span>-->
<!--            </div>-->
<!--            <span class="icon-arrow"></span>-->
<!--          </div>-->
<!--          <p class="error">{{ $t('personalInformation.error_tip.lang8') }}</p>-->
<!--        </div>-->
<!--        <van-popup v-model="jobAgePicker" position="bottom" class="picker-ui">-->
<!--          <van-picker-->
<!--            :columns="getInitList(3)"-->
<!--            show-toolbar-->
<!--            @cancel="jobAgePicker = false"-->
<!--            :default-index="getSelectText(3,2)"-->
<!--            @confirm="onjobAgeConfirm"-->
<!--          />-->
<!--        </van-popup>-->

<!--        <div class="ipt-box" :class="{'focus':inputFocusId == 5}">-->
<!--          <div class="ipt-main">-->
<!--            <div class="val-box" :class="{'zIndex':emailSuffixShow}">-->
<!--              <span class="label" v-if="personForm.company_phone || inputFocusId == 5">{{ $t('personalInformation.company_phone_field.label') }}</span>-->
<!--              <van-field-->
<!--                class="val"-->
<!--                v-model="personForm.company_phone"-->
<!--                :placeholder="inputFocusId == 5 ? '' : $t('personalInformation.company_phone_field.label')"-->
<!--                @focus="inputFocus(5)"-->
<!--                @blur="handError"-->
<!--              ></van-field>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="ipt-box" :class="{'focus':inputFocusId == 6}">-->
<!--          <div class="ipt-main">-->
<!--            <div class="val-box" :class="{'zIndex':emailSuffixShow}">-->
<!--              <span class="label" v-if="personForm.company_address || inputFocusId == 6">{{ $t('personalInformation.company_address_field.label') }}</span>-->
<!--              <van-field-->
<!--                class="val"-->
<!--                v-model="personForm.company_address"-->
<!--                :placeholder="inputFocusId == 6 ? '' : $t('personalInformation.company_address_field.label')"-->
<!--                @focus="inputFocus(6)"-->
<!--                @blur="handError"-->
<!--              ></van-field>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div v-if="personForm.job_type == 5" >
        <div class="ipt-box">
          <div class="ipt-main" @click="careerDescriptionPicker = true">
            <div class="val-box" :class="{'zIndex':emailSuffixShow}">
            <span class="label" :class="{ placeholder: !personForm.job_type_other_describe }"
            >{{ $t('personalInformation.employment_field.placeholder_other') }}</span
            >
              <span class="val" v-if="personForm.job_type_other_describe">{{ getSelectText(5,1) }}</span>
            </div>
            <span class="icon-arrow"></span>
          </div>
        </div>
        <van-popup v-model="careerDescriptionPicker" position="bottom" class="picker-ui">
          <van-picker
            :columns="getInitList(5)"
            show-toolbar
            @cancel="careerDescriptionPicker = false"
            :default-index="getSelectText(5,2)"
            @confirm="careerDescriptionConfirm"
          />
        </van-popup>
      </div>
      <div class="fix-dom"></div>

      <nav-buttons @on-next="handRecommend" :disabled="getNextDisabled" navigationType="back" :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')"></nav-buttons>
    </div>

    <van-dialog v-model="emailResultShow" class="email-dialog" :showConfirmButton="false" title="" :className="bgColor == 'black-theme' ? 'darkOrLight':''">
      <div class="dialog-title">{{ $t('personalInformation.error_tip.lang9') }}</div>
      <div class="dialog-content">{{ $t('personalInformation.error_tip.lang10') }}</div>
      <div class="dialog-tip">{{ $t('personalInformation.error_tip.lang11') }}</div>
      <div class="dialog-confirm">
        <div class="confirm-btn" @click="handEmailSuccess">{{ $t('personalInformation.error_tip.lang12') }}</div>
      </div>
    </van-dialog>


  </div>
</template>

<script>
import { Dialog, Field, Icon, Picker, Popup, Toast,Overlay,Cell,CellGroup } from "vant";
import navButtons from "../components/navButtons.vue";
import Progress from "../components/Progress.vue";
import { isEmail } from '@/utils/verify'
import { getBrowser } from "@/utils/browser";

export default {
  components: {
    VanField: Field,
    VanPopup: Popup,
    VanPicker: Picker,
    VanIcon: Icon,
    [Dialog.Component.name]: Dialog.Component,
    VanOverlay:Overlay,
    VanCell:Cell,
    VanCellGroup:CellGroup,
    Progress,
    navButtons
  },
  data() {
    return {
      topDistance: 0,
      dialogWidth: 0,
      personForm: {
        user_phone: "",
        email: "",
        education: "3",
        job_type: "1",
        company: "",
        vocation_attribute: "careerAttributes1",
        vocation: "",
        job_age: "",
        company_address: "",
        company_phone: "",
        job_type_other_describe: "careerDescription1",
        zone_code: ""
      },
      educationalPicker: false, // 最高学历弹窗
      careerPicker: false, //职业状况
      jobAgePicker: false,
      emailResultShow: false,
      process_id:'',
      errorStatus:false,
      emailSuffixShow:false, // 邮箱尾缀是否展示
      emailSuffixList:[],
      inputFocusId:null,
      resultEmail:[],
      careerAttributesPicker: false,
      careerAttributesList: [],
      careerDescriptionPicker: false,
      careerDescriptionList: []
    };
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getNextDisabled(){
      let btnDisabled = false

      let personFormKey = ['email', 'education'];  // 必填的两个字段
      if(this.personForm.job_type && (this.personForm.job_type == 1 || this.personForm.job_type == 2)){ // 职业类型为受雇与自雇类型必填的字段
       personFormKey = ['company', 'vocation_attribute','vocation','email', 'education'];
      }
      for (let i = 0; i < personFormKey.length; i++){
        if(!this.personForm[personFormKey[i]]){
          btnDisabled = true;
        }
      }
      if(this.personForm.job_type && this.personForm.job_type == 5){ // 职业类型为其他时校验必填字段
        if (!this.personForm.job_type_other_describe) {
          btnDisabled = true
        }
      }
      return btnDisabled
    },
    getApp(){
      return getBrowser().isApp
    },
  },
  created() {
    this.getCareerAttributesEnum();
    this.getCareerDescriptionEnum()
    this.getInitList();
    this.handDetail();
    this.getEmailEnum();
  },
  methods: {
    // 初始化三个数组的数据
    getInitList(e){
      const key = {
        1: this.$t("personalInformation.employment_field.columns"), // 职业状况
        2: this.$t("personalInformation.education_field.columns"), // 最高学历
        3: this.$t("open_account.personal_info_supply.employment_duration_field.columns"),// 职业
        4: this.careerAttributesList,
        5: this.careerDescriptionList
      }
      return key[e]
    },
    // 获取邮箱尾缀
    getEmailEnum(){
      const params = {
        key:'emailSuffix'
      }
      this.$apis.getEnum(params).then(res =>{
          if(res){
            const email = res['0']?.value_display?.split(',') || []
            this.emailSuffixList = email
            this.resultEmail = email
          }
      })
    },
    getCareerAttributesEnum(){
      const params = {
        key:'careerAttributes'
      }
      this.$apis.getEnum(params).then(res =>{
        if(res){
          this.careerAttributesList = res.map(e => {
            e.text = e.value_display
            return e;
          })
        }
      })
    },

    getCareerDescriptionEnum(){
      const params = {
        key:'careerDescription'
      }
      this.$apis.getEnum(params).then(res =>{
        if(res){
          this.careerDescriptionList = res.map(e => {
            e.text = e.value_display
            return e;
          })
        }
      })
    },
    handDetail() {
      const toastLoading1 = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      const params = {
        step_code:'1,6'
      }
      this.$apis.accountSituationV2(params).then(res => {
        toastLoading1.clear()
        this.personForm.user_phone = res?.phone;
        this.personForm.zone_code = res?.zone_code;
        this.process_id = res?.process_info["1"]?.process_id;
        const { config_data } = res?.process_info?.["6"] || {};
        if (config_data) {
          const form = JSON.parse(config_data);
          this.personForm = form
          this.personForm.user_phone = res?.phone;
          this.personForm.zone_code = res?.zone_code;
          this.getSelectText()
        }
      });
    },
    // 最高学历选择
    onEducationalConfirm(e) {
      this.educationalPicker = false;
      this.personForm.education = e.value;
    },
    onCareerConfirm(e) {
      this.careerPicker = false;
      this.personForm.job_type = e.value;
    },
    careerAttributesConfirm(e){
      this.careerAttributesPicker = false;
      this.personForm.vocation_attribute = e.value;
    },
    careerDescriptionConfirm(e){
      this.careerDescriptionPicker = false;
      this.personForm.job_type_other_describe = e.value;
    },
    onjobAgeConfirm(e) {
      this.jobAgePicker = false;
      this.personForm.job_age = e.value;
    },
    // 获取选中的值
    getSelectText(type,i){
      const valueList =  this.getInitList(type)
      if(valueList && valueList.length > 0){
        if(i == 1){
          if(type == 2 && this.personForm.education){
            return valueList.find(item => item.value == this.personForm.education).text
          }
          if(type == 1 && this.personForm.job_type){
            return valueList.find(item => item.value == this.personForm.job_type).text
          }
          if(type == 3 && this.personForm.job_age){
            return valueList.find(item => item.value == this.personForm.job_age).text
          }
          if(type == 4 && this.personForm.vocation_attribute){
            const item = valueList.find(item => item.value == this.personForm.vocation_attribute);
            return item ? item.text : this.personForm.vocation_attribute
          }
          if(type == 5 && this.personForm.job_type_other_describe){
            const item = valueList.find(item => item.value == this.personForm.job_type_other_describe);
            return item ? item.text : this.personForm.job_type_other_describe
          }
        }else{
          if(type == 2 && this.personForm.education){
            return valueList.findIndex(item => item.value == this.personForm.education)
          }
          if(type == 1 && this.personForm.job_type){
            return valueList.findIndex(item => item.value == this.personForm.job_type)
          }
          if(type == 3 && this.personForm.job_age){
            return valueList.findIndex(item => item.value == this.personForm.job_age)
          }
          if(type == 4 && this.personForm.vocation_attribute){
            const _index = valueList.findIndex(item => item.value == this.personForm.vocation_attribute);
            return _index < 0 ? 0 : _index;
          }
          if(type == 5 && this.personForm.job_type_other_describe){
            const _index = valueList.findIndex(item => item.value == this.personForm.job_type_other_describe);
            return _index < 0 ? 0 : _index;
          }
        }
      }
    },
    // 校验空
    handError(e){
      this.inputFocusId = ''
      this.emailSuffixShow = false;
      // this.errorStatus = false
      // if(!e){
      //   this.errorStatus = true
      // }
    },

    // 选择尾缀
    handSuffixClick(item){
      if(this.personForm.email.indexOf('@') > -1){
        this.personForm.email = `${this.personForm.email.split('@')[0]}${item}`
      }else{
        this.personForm.email = `${this.personForm.email}${item}`
      }
    },

    inputFocus(id){
      this.inputFocusId = id;
    },

    handEmailSuffix(e){
      this.emailSuffixShow = true
      this.personForm.email = e.trim()
      if(e.indexOf('@') > -1){
        const filteredDomains = this.resultEmail.filter(domain => domain.includes(e.split('@')[1]));
        this.emailSuffixList = filteredDomains
      }
      if(this.emailSuffixList.length == 0 || !this.personForm.email || (this.personForm.email.indexOf('@') > 0 && this.personForm.email.indexOf('.') > 0) ){
        this.emailSuffixShow = false
      }
      this.$nextTick(() => {
        const ele = document.querySelector('.email');
        this.topDistance = ele?.offsetHeight - 10 || 0;
        this.dialogWidth = ele?.offsetWidth || 0;
      })
    },



    async handRecommend() {
      if(this.getNextDisabled){
        this.errorStatus = true
        return
      }
      let { personForm } = this;
      // if(personForm.education == 1){
      //   return Toast(this.$t("openAccount.t000178"));
      // }
      if(this.personForm.job_type && (this.personForm.job_type == 3 || this.personForm.job_type == 4)){
        personForm = {
            user_phone: personForm.user_phone,
            email: personForm.email.trim(),
            education: personForm.education,
            job_type: personForm.job_type,
            company: "",
            vocation_attribute: "",
            vocation: "",
            job_age: "",
            company_address: "",
            company_phone: "",
            job_type_other_describe: ""
        }
      }

      if(this.personForm.job_type && this.personForm.job_type == 5){ // 职业类型为其他时校验必填字段
        personForm = {
          user_phone: personForm.user_phone,
          email: personForm.email.trim(),
          education: personForm.education,
          job_type: personForm.job_type,
          company: "",
          vocation_attribute: "",
          vocation: "",
          job_age: "",
          company_address: "",
          company_phone: "",
          job_type_other_describe: personForm.job_type_other_describe
        }
      }
      const params = {
        process_id:this.process_id,
        step_code: 6,
        step_order: 6,
        config_data: {
          ...personForm
        }
      };
      if(!isEmail(personForm.email.trim())){
        return Toast( this.$t('personalInformation.error_tip.lang13'))
      }

      try {
        const checkEmail = await this.$apis.accountSendEmail({ email:personForm.email })
        if(checkEmail.is_pass == 0){
          return Toast(this.$t('personalInformation.emailErrorTip'))
        }
      }catch(e){
        
      }
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis.supplementSaveApi(params).then(res => {
        if (res) {
          toastLoading.clear();
          this.emailResultShow = true;
        }
      })
    },
    handEmailSuccess() {
      this.emailResultShow = false;
      let path = "/open-account/suitabilitySurvey";
      if(this.$route.query.change == 1){
        path = "/open-account/home"
      }
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="less" scoped>
.person-header {
  padding-top: 62px;
  .header-title {
    color: #17161c;
    font-size: 36px;
    font-weight: 500;
    line-height: 88px;
    padding: 14px 32px 0;
    border-bottom: #f3f3f3 solid 1px;
  }

  .email-tip {
    font-size: 24px;
    color: #F24E1E;
    margin-top: 12px;
    padding: 0px 32px;
  }

  .header-title1 {
    color: #000;
    font-weight: 500;
    margin-top: 26px;
    font-size: 36px;
    padding: 0px 32px;
    line-height: 88px;
    border-bottom: #f3f3f3 solid 1px;
  }
}

.foot-btn {
  margin: 40px;
}

.email-input::placeholder {
  font-size: 28px;
  color: #747377;
}

.card {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 132px;
  border: 1px solid rgba(23, 22, 28, 0.45);
  border-radius: 8px;
  padding: 20px 32px;
  box-sizing: border-box;
  margin-top: 20px;

  .left {
    display: flex;
    flex-direction: column;
    flex: 1;

    .value {
      color: #17161C;
      font-weight: 500;
    }
  }
}

.card1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100px;
  border: 1px solid rgba(23, 22, 28, 0.45);
  border-radius: 8px;
  padding: 20px 32px;
  box-sizing: border-box;
  margin-top: 20px;

  .left {
    display: flex;
    flex-direction: column;
    flex: 1;

    .value {
      color: #17161C;
      font-weight: 500;
    }
  }
}
/deep/ .email-dialog {
  .van-dialog__content {
    padding-top: 0px !important;
  }
  .van-dialog__footer {
    padding-bottom: 0px !important;
  }
}

.dialog-title {
  width: 100%;
  text-align: center;
  color: #17161C;
  font-size: 36px;
  font-weight: 600;
  margin-top: 46px;
}

.dialog-content {
  width: 100%;
  text-align: center;
  color: #747377;
  font-size: 32px;
  font-weight: 400;
  margin-top: 32px;
}

.dialog-tip {
  width: 100%;
  text-align: center;
  color: #F24E1E;
  font-size: 28px;
  font-weight: 400;
  margin-top: 16px;
}

.dialog-confirm {
  width: 100%;
  margin-top: 48px;
  margin-bottom: 56px;

  .confirm-btn {
    width: 496px;
    height: 104px;
    text-align: center;
    line-height: 104px;
    background: #17161C;
    color: #FFFFFF;
    font-size: 28px;
    font-weight: 500;
    border-radius: 200px;
    margin: 0 auto;
  }
}

.no-job-select {
  color: #C8C9CC !important;
}

.other-box {
  // margin-bottom: 25%;
}
.other-box1{
  margin-bottom: 30%;
}
.error-text{
  margin-top: 10px;
  font-size: 24px;
  color: #CC0000;
}
.error-box{
  border-color: #CC0000 !important;
}
.form-label1{
  font-size: 24px;
  color: #747377;
}
.ipt-box {
  margin-bottom: 24px;
  padding: 0px 32px;
  &.focus{
    border-color: #17161C;
    .ipt-main{
      &:after{
        border-color: #17161C;
      }
      ::v-deep .van-cell{
        input {
          &::placeholder {
            font-size: 0;
          }
        }
      }
    }
  }
  &.error{
    .ipt-main {
      &:after {
        border-color: #FD2626;
      }
    }
  }
  .ipt-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    min-height: 56px;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .val-box {
      position: relative;
      flex: 1;
      display: flex;
      z-index: 1;
      flex-direction: column;
      line-height: 1;
      font-size: 32px;
      .phone {
        font-weight: 500;
      }
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
        &.placeholder {
          padding: 12px 0 6px 0;
          font-size: 28px;
          animation: none;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        input{
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
          &:focus ~ .van-field__body{
            background: red;
          }
        }
        textarea {
          font-size: 32px;
          line-height: 35px;
          min-height: 70px;
          color: #17161c;
        }
      }
      .val {
        padding: 0;
        line-height: 36px;
        color: #17161c;
        font-weight: 500;
      }
    }
    .icon-arrow {
      width: 32px;
      height: 32px;
      background: url("../../../assets/images/arrow-down.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;
    &.show{
      display: block;
    }
    &.right{
      text-align: right;
    }
  }
  &.error{
    .ipt-main{
      border-color: #fd2626;
    }
    .error{
      display: block;
    }
  }
}
.isdisable{
  margin-top: 36px;
  color: #B9B9B9;
  .label {
    color: #B9B9B9 !important;
  }
  .ipt-main{
    background: #F9FAFC;
  }
}
.isdisable1{
  margin-top: 36px;
}

.black-theme{
  .person-header{
    .header-title{
      color: #FFFFFF;
      border-color: #323442 !important;
    }
    .header-title1 {
      border-color: #323442 !important;
    }
  }
  .phone-box{
       border: 1px solid rgba(255,255,255,0.45);
      .phone-title{
        color: #9D9D9F;
      }
  }
  .isdisable{
    .ipt-main{
      background: #14151D;
    }
  }

  .email-box{
    border: 1px solid rgba(255,255,255,0.45);
  }
  .email-tip{
    color: #F24E1E;
  }
  .header-title1{
    color: #FFFFFF;
  }
  .card{
    border: 1px solid rgba(255,255,255,0.45);
    .label{
      color: #9D9D9F;
      font-size: 24px;
    }
    .value{
      color: #FFFFFF;
    }
  }
  .card1{
    border: 1px solid rgba(255,255,255,0.45);
    .form-label1{
      color: #9D9D9F;
      font-size: 24px;
    }
    .value{
      color: #FFFFFF;
    }
  }
  .darkOrLight{
    background: #1B1C24;
    .dialog-title{
      color: #FFFFFF;
    }
    .dialog-content{
      color: #9D9D9F;
    }
    .confirm-btn{
      background: #377CFB;
    }
  }
  .ipt-box{
    &.focus{
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,1);
        }
      }
    }
    &.error{
      .ipt-main{
        &:after{
          border-color: #fd2626;
        }
      }
    }
    .ipt-main{
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      .label{
        color: #9D9D9F;
      }
      .icon-arrow{
        background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }
      .val{
        color: #fff;
        ::v-deep{
          .van-cell__value input::placeholder {
            color: #9D9D9F !important;
          }
          textarea{
            color: #fff;
          }
        }
      }
    }
  }
  .symbolList-box {
    max-height: 300px;
    overflow-y: auto;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    background-color: #14151D;
  }
  .cell-box{
    background: #14151D;
    color: #FFFFFF;
  }
}
.overlay-top {
  // margin-top: 77.5%;
  position: absolute;
  z-index: 1000;
  max-width: 1000px;
  // transform: translateX(-50%);
  // left:50%;
  left: -30px;
  right: 0;
  background: transparent !important;
}
.overlay-top-app {
  margin-top: 66%;
  z-index: 1000;
  max-width: 1000px;
  transform: translateX(-50%);
  left:50%
}
/deep/ .van-overlay{
  // background: transparent;
}
.none-value{
  margin-top: 74%;
}
.none-value-app{
  margin-top: 62%;
}
.symbolList-box {
  max-height: 300px;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 12px 0px rgba(23,22,28,0.08);
  // margin-left: 32px;
  // margin-right: 32px;
  padding: 0px 32px;
}
.cell-box{
  padding: 30px 0px;
  background: #FFFFFF;
}
.zIndex{
  z-index: auto !important;
}
/deep/ .van-cell::after{
  border-bottom: 0px;
}
.fix-dom{
  height: 200px;
}




</style>
